<gs1-footer [breakWidth]="835">
  <a><unsubscribe></unsubscribe></a>
  <a class="tiny-link footer-link" name="footer-cgu" (click)="CGU()" angulartics2On="click" angularticsAction="CGUFooter">{{ 'footer.CGU' | translate }}</a>
  <a class="tiny-link footer-link" name="footer-confidentiality" (click)="PolitiqueConfidentialite()" angulartics2On="click" angularticsAction="PolitiqueConfidentialiteFooter">{{
    'footer.PolitiqueConfidentialite' | translate
  }}</a>
  <a class="tiny-link footer-link" name="footer-legal" routerLink="/mentions-legales" angulartics2On="click" angularticsAction="MentionsLegalesFooter">{{
    'footer.MentionsLegales' | translate
  }}</a>
</gs1-footer>
